import tjFetch from '@common-libs/tj-fetch'

// apiConfig
let apiConfig = {}
// 领取体验会员
apiConfig.receiveExMember = '/bnbapp-node-h5/h5/user/receiveexmember/bnb'

let api = {}

api.receiveExMember = function() {
  return tjFetch.post(apiConfig.receiveExMember, {
    data: arguments[0]
  })
}

export default api
